import { IconButton, useTheme } from '@mui/material';
import React from 'react';

interface ButtonIconProps {
	isActive?: boolean;
	onClick?: (e: any) => void;
	children: React.ReactNode;
	sx?: object;
	disabled?: boolean;
	[key: string]: any;
}

const ButtonIcon = React.forwardRef<HTMLButtonElement, ButtonIconProps>(({ isActive, children, onClick, sx, disabled, ...props }, ref) => {
	const theme = useTheme();

	return (
		<IconButton
			ref={ref}
			onClick={disabled ? undefined : onClick}
			disabled={disabled}
			{...props}
			sx={{
				color: isActive ? theme.palette.primary.main : theme.palette.secondary.main, // Couleur de l'icône
				'&:hover': {
					color: disabled ? 'inherit' : (isActive ? theme.palette.primary.main : 'black'), // Pas de changement de couleur au survol si désactivé
				},
				...sx // Intégration de sx dans les styles
			}}
		>
			{children} 
		</IconButton>
	);
});

ButtonIcon.displayName = 'ButtonIcon';

export default ButtonIcon;